module.exports = __webpack_public_path__ + "static/img/ds-nan@2x.51d5250c.png";